<template>
	<span :class="settings?.class">{{ localData }}</span>
</template>

<script>
	import _ from 'lodash'

	export default {
		name: "nk-tag",
		props: {
			options: Object,
			data: ''
		},
		mounted() {
			this.settings = _.cloneDeep(this.options)
			this.localData = this.data
			if (this.params?.options) this.settings = _.merge(this.settings, this.params.options)
			if (this.params?.value) this.localData = this.params.value
		},
		data() {
			return {
				settings: {},
				localData: '',
			}
		}
	}
</script>

<style scoped></style>